<template>
  <no-auth-layout @back="handleBack">
    <div class="pt-[32px] px-[24px] md:mx-auto md:max-w-[552px] md:px-0">
      <!-- STEP 1 -->
      <EmailInput v-if="step === 1" @next="goToStep(2)" />

      <!-- STEP 2 -->
      <VerifyOTP v-if="step === 2" :email="email" @success="goToStep(3)" />
      <!-- STEP 3 -->
      <NewPasswordForm v-if="step === 3" @next="goToStep(4)" />
      <!-- STEP 4 -->
      <SuccessMessage v-if="step === 4" />
    </div>
  </no-auth-layout>
</template>
<script>
import NoAuthLayout from '@/components/NoAuth.vue';
import EmailInput from '@/components/ForgotPassword/EmailInput.vue';
import VerifyOTP from '@/components/ForgotPassword/VerifyOTP.vue';
import NewPasswordForm from '@/components/ForgotPassword/NewPasswordForm.vue';
import SuccessMessage from '@/components/ForgotPassword/SuccessMessage.vue';
import { mapState } from 'vuex';

export default {
  components: {
    NoAuthLayout,
    EmailInput,
    VerifyOTP,
    NewPasswordForm,
    SuccessMessage,
  },
  computed: {
    ...mapState('forgotCredentials', ['step', 'email']),
  },
  methods: {
    goToStep(stepNumber) {
      this.$store.commit('forgotCredentials/setStep', stepNumber);
    },
    handleBack() {
      if (this.step > 1) {
        this.$store.commit('forgotCredentials/setStep', 1);
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>
